/* Rebuy Events -- Start: close smart cart drawer when Rebuy SmartCart hides */
document.addEventListener('rebuy:smartcart.hide', (event) => {
  // const { smartcart } = event.detail;
  document.body.classList.remove("js-drawer-open")
});
/* Rebuy Events -- End */

/* Mobile Menu: toggle mobile navigation drawer and body state */
jQuery('.header-section--wrapper .site-nav--mobile button').click(function(){
  // jQuery("body").toggleClass('active-menu');
  jQuery(this).toggleClass('active');
  jQuery(".mobile-navigation-menu").toggleClass('mm-active');
  jQuery("html").toggleClass('mm-menu-open');
});

/* Anchor Scroll Helpers: keep track of last clicked anchor and adjust scroll for sticky header */
let topValue = 0;
let clickedElement = '';

// Shared helper: get dynamic header height based on viewport and header/mobile nav elements
function getDynamicHeaderHeight() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  let header = null;

  // For widths below 989px, prefer the mobile nav bar wrapper
  if (viewportWidth < 989) {
    header = document.querySelector('.mobile-nav-bar-wrapper');
  } else {
    // For widths 989px and above, prefer the site-header
    header =
      document.querySelector('header.site-header') ||
      document.querySelector('.site-header');
  }

  // Fallbacks if preferred header is not found
  if (!header) {
    header =
      document.querySelector('.main-header') ||
      document.querySelector('.header-section--wrapper');
  }

  let headerHeight = header ? header.getBoundingClientRect().height : 0;

  // On very small screens (< 767px), slightly reduce the effective header height
  if (viewportWidth < 767 && headerHeight > 0) {
    headerHeight = Math.max(headerHeight - 20, 0);
  }

  return headerHeight;
}

$(window).scroll(function(){
  if(clickedElement){
    if(clickedElement.offset().top > topValue){
      topValue = clickedElement.offset().top;
      $('html, body').scrollTop(
        topValue - getDynamicHeaderHeight()
      );
    }
  }
});

// Function to handle scrolling with dynamic header height
function scrollToTarget() {
  $('.column-link-anchor').click(function(e) {
    e.preventDefault();
    var target = $($(this).attr('href'));
    if(target.length){
      var headerHeight = getDynamicHeaderHeight();
      var scrollTo = target.offset().top - headerHeight - 40;

      $('body, html').animate({scrollTop: scrollTo}, 800);
    }
  });
}

// Call the scroll function on page load
$(document).ready(function() {
  scrollToTarget();
});

// Recalculate the scroll position if window is resized
$(window).resize(function() {
  scrollToTarget(); // Recalculate on resize
});

/* Wood Care page anchors: handle scroll and lazy image loading before scroll */
jQuery(document).ready(function($) {
  // Wood Care Page
  $('.click-to-goSection').click(function (e){
    e.preventDefault()
    var headerHeight = getDynamicHeaderHeight();
    $('html, body').animate({
      scrollTop: $("#Content_Section").offset().top - headerHeight
    }, 500)
  })

  $('.content-left p a').on('click', function(e) {
    if (this.hasAttribute('href') && this.getAttribute('href').startsWith('#')) {
        e.stopPropagation();
        e.preventDefault();
        
        const images = document.querySelectorAll('img.is-lazy');
        const updateImageSrcPromises = Array.from(images).map(img => {
            return new Promise((resolve) => {
                const src = img.getAttribute('data-original-src');
                if (src) {
                    img.onload = () => resolve();
                    img.src = src;
                    img.classList.remove('lazyload');
                    img.classList.remove('is-lazy');
                    img.removeAttribute('loading');
                } else {
                    resolve();  // If there's no data-original-src, resolve immediately
                }
            });
        });

        const targetId = this.getAttribute('href').slice(1);

        Promise.all(updateImageSrcPromises).then(() => {
            const $targetElement = $('#' + targetId);
            if ($targetElement.length > 0) {
                var headerHeight = getDynamicHeaderHeight();
                $('html, body').animate({
                    scrollTop: $targetElement.offset().top - headerHeight
                }, 1000);
            }
        });
    }
  });

});

/* Custom Filter JS: click on icon filter bubbles to drive collection filters and scroll into view */
if (document.querySelectorAll('.shop-by-bowl-item').length) {
  document.querySelectorAll('.shop-by-bowl-item').forEach(function (ele) {
    ele.addEventListener('click', function (e) {
      const current = e.currentTarget;
      const targetData = current.getAttribute('data-filter');
      if (!targetData) return;

      // Nested hash links also scroll; keep filter click from navigating away
      const nestedLink = e.target.closest('a');
      if (nestedLink) {
        const href = nestedLink.getAttribute('href') || '';
        if (href.startsWith('#')) e.preventDefault();
      }

      const wasActive = current.classList.contains('active');
      const filterName = 'filter.p.m.custom.collection_filters';

      // Always clear every other bowl item + uncheck all matching inputs (desktop + mobile)
      document.querySelectorAll('.shop-by-bowl-item').forEach(function (item) {
        if (item === current) return;

        item.classList.remove('active');

        const otherValue = item.getAttribute('data-filter');
        if (!otherValue) return;

        document.querySelectorAll(
          `input[name="${filterName}"][value="${otherValue}"]`
        ).forEach(function (input) {
          input.checked = false;
        });
      });

      // Toggle current: 1st click selects, 2nd click deselects
      if (wasActive) {
        current.classList.remove('active');
      } else {
        current.classList.add('active');
      }

      const currentFilters = document.querySelectorAll(
        `input[name="${filterName}"][value="${targetData}"]`
      );
      if (!currentFilters.length) return;

      const shouldCheck = !wasActive;
      currentFilters.forEach(function (input) {
        input.checked = shouldCheck;
      });

      // Fire one input event so the theme filter form updates once with correct FormData
      currentFilters[0].dispatchEvent(new Event('input', { bubbles: true }));

      // Scroll immediately (no artificial delay) so mobile feels responsive
      const collectionSection = document.getElementById('shopify-collection-section');
      if (!collectionSection) return;

      const scrollToCollection = function () {
        const headerHeight = getDynamicHeaderHeight();
        const sectionTop = collectionSection.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: sectionTop - headerHeight, behavior: 'smooth' });
      };

      scrollToCollection();

      // If filter results re-render the section, nudge scroll once more after update
      const observer = new MutationObserver(function () {
        scrollToCollection();
        observer.disconnect();
      });
      observer.observe(collectionSection, { childList: true, subtree: true });
      setTimeout(function () {
        observer.disconnect();
      }, 2000);
    });
  });
}

/* Rebuy product grid: wait for grid, then equalize product media heights */
let height_interval = null
let domWorks = () => {
  let d = document.querySelector('.rebuy-product-grid');
  if(d){
    setTimeout(function() {
      $('.rebuy-product-block').each(function() {
        $('.rebuy-product-media').matchHeight();
      })
    },500);
    clearInterval(height_interval) 
  }
}
height_interval = setInterval(domWorks, 100)

/* Engraving: disable ATC when checked and text is empty; allow ATC when unchecked */
function syncEngravingFieldState(form) {
  if (!form || !form.length) return;

  const checkbox = form.find('#hc-additional-product-engraving');
  const fieldWrapper = form.find('.hc-field-wrapper');
  const engravingField = form.find('#engraving');
  const submitButton = form.find('[type="submit"][name="add"], .product--add-to-cart-button');

  if (!checkbox.length || !engravingField.length) return;

  const isChecked = checkbox.is(':checked');
  const hasValue = engravingField.val().trim() !== '';
  const isSoldOutDisabled = submitButton.is(':disabled') && submitButton.attr('data-engraving-disabled') !== 'true';

  if (isChecked) {
    fieldWrapper.show();
    engravingField.attr('required', 'required');

    if (!hasValue) {
      if (engravingField[0]) {
        engravingField[0].setCustomValidity(
          engravingField.data('error-message') || 'Please enter your engraving message, or type "Contact me".'
        );
      }
      if (!isSoldOutDisabled) {
        submitButton.prop('disabled', true).attr('data-engraving-disabled', 'true');
      }
    } else {
      if (engravingField[0]) engravingField[0].setCustomValidity('');
      if (submitButton.attr('data-engraving-disabled') === 'true') {
        submitButton.prop('disabled', false).removeAttr('data-engraving-disabled');
      }
    }
  } else {
    fieldWrapper.hide();
    engravingField.removeAttr('required');
    engravingField.val('');
    if (engravingField[0]) engravingField[0].setCustomValidity('');
    fieldWrapper.find('.required-field-error').remove();
    form.find('#engravingSubmit.required-field-error').remove();

    if (submitButton.attr('data-engraving-disabled') === 'true') {
      submitButton.prop('disabled', false).removeAttr('data-engraving-disabled');
    }
  }
}
window.syncEngravingFieldState = syncEngravingFieldState;

$(document).on('change', '#hc-additional-product-engraving', function () {
  const form = $(this).closest('form');
  if ($(this).is(':checked')) {
    form.find('#engraving').val('');
  }
  syncEngravingFieldState(form);
});

$(document).on('input', '#engraving', function () {
  syncEngravingFieldState($(this).closest('form'));
});

$(function () {
  $('form').each(function () {
    syncEngravingFieldState($(this));
  });
});

/* Re-apply engraving lock after variant availability updates the ATC button */
function reSyncEngravingAfterVariant() {
  setTimeout(function () {
    $('form').each(function () {
      syncEngravingFieldState($(this));
    });
  }, 0);
}

function bindEngravingVariantListeners() {
  if (!window.eventBus || window.__engravingVariantListenersBound) return;
  window.__engravingVariantListenersBound = true;
  window.eventBus.on('variant:change', reSyncEngravingAfterVariant);
  window.eventBus.on('variant:updated', reSyncEngravingAfterVariant);
}

bindEngravingVariantListeners();
$(bindEngravingVariantListeners);

/* Rebuy SmartCart: update cart title count and empty state */
function checkCartItemsCount(){
  const SmartCart = window.Rebuy.SmartCart;
  if (SmartCart) {
    var cartCount = SmartCart.itemCount();
    $('.rebuy-cart__flyout-title').text('Your Bag ('+ cartCount +')');
    if(cartCount == 0){
      $('.rebuy-cart__flyout').addClass('empty-cart');
    }else{
      $('.rebuy-cart__flyout').removeClass('empty-cart');
    }
  }
}

/* Rebuy cart events: keep cart count text in sync */
document.addEventListener('rebuy:cart.ready', (event) => { 
  checkCartItemsCount();
});

document.addEventListener('rebuy:cart.change', (event) => { 
  checkCartItemsCount();
});

/* Cart drawer: show gift message textarea */
$(document).on('click','.cart_gift_msg_add',function(){
  $('.cart-gift_msg__content').addClass('active');
  $(this).addClass('remove_gift_msg');
  $(this).text('Remove gift message');
});

/* Cart drawer: show special instructions textarea */
$(document).on('click','.cart_note_add',function(){
  $('.cart-note__content').addClass('active');
  $(this).addClass('remove_note');
  $(this).text('Remove note');
});

/* Rebuy helper: add a product to cart by variant ID */
function rebuyProductAdd(variantID){
  $.ajax({
   type: 'POST',
   url: '/cart/add.js',
   async: false,
   data: 'quantity=1&id=' + variantID,
   dataType: 'json',
   success: function(data) {}
  });
}

/* Rebuy helper: remove a product from cart by variant ID */
function rebuyProductRemove(variantID){
  $.ajax({
   type: 'POST',
   url: '/cart/change.js',
   async: false,
   data: 'quantity=0&id=' + variantID,
   dataType: 'json',
   success: function(data) {}
  });
}

/* Sync checkbox options with Rebuy add/remove actions */
$(document).on('click','.custom_options_container input',function(){
  var variantID = $(this).data('product');
  if($(this).is(":checked")){
    rebuyProductAdd(variantID);
  }else{
    rebuyProductRemove(variantID);
  }
});

/* Cart note and gift message typing: debounce updates and support aborting in-flight requests */
$(document).ready(function(){
    var typingTimer;
    var doneTypingInterval = 1000;
    var controller; // AbortController object

    // Debounced cart note updates
    $(document).on('input','.cart_note-textarea', function() {
        var enteredText = $(this).val();
        // Abort the previous request, if any
        if (controller) {
            controller.abort();
        }
        
        // Create a new AbortController
        controller = new AbortController();
        var signal = controller.signal;

        // Start a new timer for the AJAX request
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function() {
            setCartNoteOnTypingDone({ 'note': enteredText }, signal);
        }, doneTypingInterval);
    });
  
    // Debounced gift message attribute updates + character counter
    $(document).on('input','.cart_gift_msg-textarea', function() {
        var maxLength = $(this).attr('maxlength');
        var currentLength = $(this).val().length;
        var remainingLength = maxLength - currentLength;
        var enteredText = $(this).val();
        $(".cart_gift_msg-textarea_count span").text("(" + currentLength + " / " + maxLength + ")");
        
        // Abort the previous request, if any
        if (controller) {
            controller.abort();
        }
        
        // Create a new AbortController
        controller = new AbortController();
        var signal = controller.signal;

        // Start a new timer for the AJAX request
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function() {
            setCartAttributesOnTypingDone({ 'gift-note': enteredText }, signal);
        }, doneTypingInterval);
    });

    // Clear gift message and hide UI
    $(document).on('click','.remove_gift_msg', function() {
        var maxLength = $('.cart_gift_msg-textarea').attr('maxlength');
        $(".cart_gift_msg-textarea_count span").text("(0 / " + maxLength + ")");
        $('.cart_gift_msg-textarea').val('');
        $('.cart-gift_msg__content').removeClass('active');
        $(this).removeClass('remove_gift_msg');
        $(this).text('Add gift message');
        setCartAttributesOnTypingDone({ 'gift-note': '' });
    });
    // Clear special instructions and hide UI
    $(document).on('click','.remove_note', function() {
        $('.cart_note-textarea').val('');
        $('.cart-note__content').removeClass('active');
        $(this).removeClass('remove_note');
        $(this).text('Add special instructions');
        setCartNoteOnTypingDone({ 'note': '' });
    });
    
    // Close special instructions UI without clearing text
    $(document).on('click','.cart_note-close', function() {
      $('.cart-note__content').removeClass('active');
      $('.cart_note_add').removeClass('remove_note');
      $('.cart_note_add').text('Add special instructions');
    });
    // Close gift message UI without clearing text
    $(document).on('click','.cart_gift_msg-close', function() {
      $('.cart-gift_msg__content').removeClass('active');
      $('.cart_gift_msg_add').removeClass('remove_gift_msg');
      $('.cart_gift_msg_add').text('Add gift message');
    });

    // Helper: update cart attributes via AJAX, with optional abort controller
    async function setCartAttributesOnTypingDone(attributes, signal) {
        try {
            const response = await fetch("/cart/update.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    attributes: attributes 
                }),
                signal: signal // Pass the signal to the fetch options
            });
            const cart = await response.json();
            
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request aborted');
            } else {
                console.error("Error setting cart attributes:", error);
            }
        }
    }

    // Helper: update cart note via AJAX, with optional abort controller
    async function setCartNoteOnTypingDone(note, signal) {
        try {
            const response = await fetch("/cart/update.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(note),
                signal: signal // Pass the signal to the fetch options
            });
            const cart = await response.json();
            
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request aborted');
            } else {
                console.error("Error setting cart attributes:", error);
            }
        }
    }
    
});

/* Rebuy SmartCart: clear engraving properties when linked line item is removed */
document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;
  const cartItems = smartcart.cart.items;
  let engravingProduct;
  if (item.properties.hasOwnProperty('_engraving_product')) {
    const engravingValue = item.properties._engraving_product;
    if(engravingValue == 'true'){
      engravingProduct = item.properties._uniqueId_engraving_product;
    }
  } 

  cartItems.forEach(function(singleItem) {
    if (singleItem.properties.hasOwnProperty('_uniqueId_main_product')) {
      var singlePropertyValue = singleItem.properties._uniqueId_main_product;
      if (engravingProduct && engravingProduct === singlePropertyValue) {
        var propertyData = JSON.stringify({
          "id": singleItem.key,
          "properties": { 'Engraving' : '' }
        })
  
       fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: propertyData
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
        })
        .catch((error) => {
          console.error('Error:', error);
        })
      }
    }
  });
});

/* Fixed header helper: keep body top padding in sync with header height when header is fixed */
jQuery(document).ready(function($) {
  var $body = $('body');
  var $header = $('header.site-header');

  function updateBodyTopPadding() {
    if (!$header.length) return;

    var headerPosition = window.getComputedStyle($header[0]).position;
    if (headerPosition === 'fixed') {
      var mastHeight = $header.outerHeight();
      $body.css('padding-top', mastHeight);
    } else {
      $body.css('padding-top', '');
    }
  }

  updateBodyTopPadding();
  $(window).on('resize', updateBodyTopPadding);
});

function applyYepsTopMargin() {
  const hasYepsTop = document.querySelector('.yeps-top-show');

  if (hasYepsTop) {
    const yepsHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--yeps-min-height')
      .trim();

    if (yepsHeight) {
      // Force override any existing margin
      document.body.style.setProperty('margin-top', yepsHeight, 'important');
    }
  } else {
    // Remove override if class not present
    document.body.style.removeProperty('margin-top');
  }
}

// Run on load
window.addEventListener('load', applyYepsTopMargin);

// Run on resize
window.addEventListener('resize', applyYepsTopMargin);

// Scroll to review widget

document.addEventListener('DOMContentLoaded', function () {
  const reviewsSection = document.getElementById('judgeme_product_reviews');
  const badge = document.querySelector('.jdgm-widget.jdgm-preview-badge');
  if (!reviewsSection) return;

  // ---- Header offset (cached + recalculated on resize) ----
  let cachedOffset = null;

  function calculateStickyOffset() {
    // Sums the height of any *actually* fixed/sticky elements at the top
    // (e.g. announcement bar + nav), instead of hardcoding one selector.
    const candidates = document.querySelectorAll(
      'header, .header-wrapper, .shopify-section-header, .announcement-bar, [data-sticky-header]'
    );
    let total = 0;
    candidates.forEach((el) => {
      const pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') {
        total += el.getBoundingClientRect().height;
      }
    });
    return total > 0 ? total + 24 : 200; // 24px breathing room, 200px fallback
  }

  function getStickyOffset(forceRecalc = false) {
    if (cachedOffset === null || forceRecalc) {
      cachedOffset = calculateStickyOffset();
    }
    return cachedOffset;
  }

  // Recalculate on resize (debounced) since header height can change
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => getStickyOffset(true), 150);
  });

  // ---- Scroll logic ----
  function scrollToReviews() {
    const offset = getStickyOffset();
    const sectionTop = reviewsSection.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: sectionTop - offset, behavior: 'smooth' });
  }

  function goToReviews() {
    const hasContent = reviewsSection.querySelector('.jdgm-rev-widg__body, .jdgm-rev');

    if (hasContent) {
      scrollToReviews();
      return;
    }

    const observer = new MutationObserver(function (_mutations, obs) {
      if (reviewsSection.querySelector('.jdgm-rev-widg__body, .jdgm-rev')) {
        obs.disconnect();
        scrollToReviews();
      }
    });
    observer.observe(reviewsSection, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
      scrollToReviews();
    }, 2000);

    // Re-correct shortly after in case layout shifts mid-scroll
    setTimeout(scrollToReviews, 700);
  }

  // ---- Single delegated click handler (badge + any #judgeme_product_reviews link) ----
  document.addEventListener(
    'click',
    function (e) {
      const trigger =
        (badge && e.target.closest('.jdgm-widget.jdgm-preview-badge')) ||
        e.target.closest('a[href="#judgeme_product_reviews"]');

      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      goToReviews();
    },
    true // capture phase — runs before Judge.me's own listeners
  );
});